import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText } from '@insurancemenu/imenu-components-lib';
import { IMSicSearch } from '@insurancemenu/imenu-components-lib/dist/components/imForm/capabilities/sic/IMSicSearch';
import SectionTitle from 'components/common/general/SectionTitle';
import DomainProductLines from 'components/common/initiate-proposal/DomainProductLines';
import {
  FollowingSectionTitleStyled,
  IMZipCodeFieldStyled,
  IMZipCountyFieldStyled,
  IMZipStateFieldStyled,
  TabIMFormStyled,
} from 'components/common/initiate-proposal/styles';
import IMEffectiveDateSelect from 'components/common/form/IMEffectiveDateSelect';
import BasicInfoStepController from 'store/pages/initiate-quote/allied/basicInfoStepController';
import { ALLIED_INITIATE_PROPOSAL_FORM_ID } from './constants';

interface Props {
  basicInfoStepController: BasicInfoStepController;
}

const AlliedInitiateProposalForm: React.FC<Props> = observer(({ basicInfoStepController }) => {
  const { form, effectiveDatesConfig, domainProductLineItems, isDomainProductLinesLoading } = basicInfoStepController;

  return (
    <TabIMFormStyled id={ALLIED_INITIATE_PROPOSAL_FORM_ID} formController={form}>
      <SectionTitle title="Basic Information" />
      <IMInputText label="Proposal Name" name="proposalName" size="full" />
      <IMEffectiveDateSelect label="Effective Date" name="effectiveDate" size="full" options={effectiveDatesConfig} />
      <IMZipCodeFieldStyled size="s" />
      <IMZipStateFieldStyled size="s" />
      <IMZipCountyFieldStyled size="s" />

      <FollowingSectionTitleStyled title="Additional Information" />
      <IMSicSearch label="SIC Code" size="full" />

      <FollowingSectionTitleStyled title="Available Product Lines" />
      <DomainProductLines domainProductLineItems={domainProductLineItems} isLoading={isDomainProductLinesLoading} />
    </TabIMFormStyled>
  );
});

export default AlliedInitiateProposalForm;
